import UserAreaController from './user-area.controller';

angular
	.module('app.user-area', [])
	.component('appUserArea', {
		templateUrl: 'layout/user-area/user-area.html',
		controller: UserAreaController
	});
